import { gql, query } from "../utils/client";

import type {
  ApiResponse,
  DiagramVisualData,
  IllustrationVisualData,
  ImageVisualData,
  LiteraryDesignUnitVisualData,
  MacroLiteraryDesignVisualData,
  TableVisualData,
} from "../types.d";

export async function getDiagramVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: DiagramVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on DiagramVisualData {
              alt
              caption
              src
              title
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}

export async function getIllustrationVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: IllustrationVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on IllustrationVisualData {
              alt
              caption
              src
              title
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}

export async function getImageVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: ImageVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on ImageVisualData {
              alt
              caption
              src
              title
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}

export async function getLiteraryDesignUnitVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ literaryDesign: LiteraryDesignUnitVisualData }>
  >({
    query: gql`
      query GetLiteraryDesign($id: ID!) {
        literaryDesign(id: $id) {
          caption
          id
          reference
          title
          usx
          html
        }
      }
    `,
    variables: {
      id,
    },
  });

  return { data: data.literaryDesign };
}

export async function getTableVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: TableVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on TableVisualData {
              body
              minWidth
              slideWidth
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}

export async function getVideoVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: TableVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on VideoVisualData {
              alt
              externalId
              src
              title
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}

export async function getMacroLiteraryDesignVisual(id: string) {
  const { data } = await query<
    ApiResponse<{ visual: { data: MacroLiteraryDesignVisualData } }>
  >({
    query: gql`
      query GetVisual($id: ID!) {
        visual(id: $id) {
          id
          data {
            ... on MacroLiteraryDesign {
              caption
              config
              id
              reference
              title
              type
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  return data.visual;
}
